export const VERSION_SERIAL_NUMBERS = {
  VERSION_INFO_CATEGORY: 2,
  MODULE_VERSION_FIELD: 1,
  ARM_MODULE: 8000,
  DSPM_MODULE: 2700,
  DSPS_MODULE: 2800,
} as const;

export const TIMING = {
  REFRESH_INTERVAL_MS: 60 * 1000,
} as const;

export type ModuleStatus =
  | 'updated'
  | 'needs_update'
  | 'not_applicable'
  | 'loading'
  | 'unknown'
  | 'error';

export type CommunicationChannelType = 'MQTT' | 'Ethernet' | null;

export interface ModuleVersions {
  arm?: string;
  dspm?: string;
  dsps?: string;
}

export interface OnlineStatus {
  isOnline: boolean | null;
  communicationChannel: CommunicationChannelType;
}

export interface InverterStatus {
  serialNumber: string;
  loggerSn: string;
  isOnline: boolean | null;
  communicationChannel: CommunicationChannelType;

  loggerVersion?: string;
  armVersion?: string;
  dspmVersion?: string;
  dspsVersion?: string;

  loggerLatestVersion?: string;
  armLatestVersion?: string;
  dspmLatestVersion?: string;
  dspsLatestVersion?: string;

  loggerStatus: ModuleStatus;
  armStatus: ModuleStatus;
  dspmStatus: ModuleStatus;
  dspsStatus: ModuleStatus;

  canUpgrade: boolean;
  canConfigure: boolean;
  isUpgrading: boolean;

  lastUpdated: Date;
  error?: string;
}

export interface ModuleStatusOptions {
  bypassMinVersion?: boolean;
  allowSameVersion?: boolean;
  isLogger?: boolean;
}
